/*
 * @Author: your name
 * @Date: 2020-11-24 09:33:11
 * @LastEditTime: 2021-05-22 11:31:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/store/mudules/localStorage.js
 */

import {
  GET_VENUE_CLOSE_POS_POPUP,
  SET_VENUE_CLOSE_POS_POPUP,
  DEL_VENUE_CLOSE_POS_POPUP
} from './mutations'

// initial state
const state = () => ({
  popupTime: ''
})

// getters
const getters = {}

// actions
const actions = {

}

// mutations
const mutations = {
  [GET_VENUE_CLOSE_POS_POPUP](state) {
    state.popupTime = localStorage.getItem('venueClosePosPopup')
  },

  [SET_VENUE_CLOSE_POS_POPUP](state, nowTime) {
    localStorage.setItem('venueClosePosPopup', nowTime)
  },

  [DEL_VENUE_CLOSE_POS_POPUP](state) {
    localStorage.removeItem('venueClosePosPopup')
    state.popupTime = ''
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}